import { Component, Vue, Watch } from 'vue-property-decorator'
import DefaultLayout from '@/components/Layouts/Default'
import { LiveList } from '@/components/Game/Matchup'
import GameFooter from '@/components/Game/Footer'
import { FormatCurrency } from '@/utils/GameUtils'

import Shepherd from 'shepherd.js'
import 'shepherd.js/dist/css/shepherd.css'
import { EventBus } from '@/utils/eventbus'

@Component
export class Lobby extends Vue {

  private tour: Shepherd.Tour | null

  private created() {
    this.$store.dispatch('SET_CLASSIC', false)

    EventBus.$once('matchupsloaded', (count: number) => {
      if (this.$route.query.mode !== 'tutorial') { return; }

      setTimeout(() => {
        if (this.tour) { return }

        this.tour = new Shepherd.Tour({
          useModalOverlay: true,
          defaultStepOptions: {
            classes: 'shadow-md bg-purple-dark',
            scrollTo: true,
          },
          steps: [
            {
              id: 'example-step',
              text: `QuickPicks Virtual is our new fast-paced game, with new betting action available all day, every day. Your goal is simple: pick which players in our head-to-head matchups will finish with the highest score, to create your own parlay card. If all your picks are correct, you win.`,
              attachTo: {
                element: '.navigation',
                on: 'bottom'
              },
              classes: 'example-step-extra-class',
              buttons: [
                {
                  text: 'Next',
                  //@ts-ignore
                  action: function() {
                    //@ts-ignore
                    return this.next();
                  }
                }
              ]
            }, {
              id: 'example-step',
              text: `Players are matched head-to-head based on their Average Fantasy score. Pick the players you predict will have the most points, based on our scoring system (listed in our How to Play section). Results are randomly drawn from players’ official game stat lines.`,
              attachTo: {
                element: '.matchups-filters',
                on: 'bottom'
              },
              classes: 'example-step-extra-class',
              buttons: [
                {
                  text: 'Next',
                  //@ts-ignore
                  action: function() {
                    //@ts-ignore
                    return this.next();
                  }
                }
              ]
            }, {
              id: 'example-step',
              text: `To make your bet, just pick a minimum of 3 players for your parlay. If you want a bigger payout, pick more players. A winning 3-pick pays out 5-to-1; a winning 10-pick pays out 500-to-1.`,
              attachTo: {
                element: '.bubble',
                on: 'top'
              },
              classes: 'example-step-extra-class',
              buttons: [
                {
                  text: 'End',
                  //@ts-ignore
                  action: function() {
                    //@ts-ignore
                    return this.next();
                  }
                }
              ]
            }
          ]
        })
    
        this.tour.on('complete', () => {
          let query = Object.assign({}, this.$route.query);
          delete query.mode;
          this.$router.replace({ query });
          //@ts-ignore
          delete this.tour
          EventBus.$off('matchupsloaded');
          this.$router.push('home')
        })

        this.tour.start()
      }, 1000)

    })
  }

  render(h: any) {

    let loader: JSX.Element | null = null
    if (this.$store.getters.LOADING) {
      loader = <div class='lds-grid'><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    }

    return (
        <DefaultLayout>
            <div slot='navigation'>
              <h1 class='navigation-title'>Daily</h1>
              <router-link class='navigation-link home' to='/home'>Home</router-link>
              <p class='navigation-user'>{this.$store.getters.USERNAME}</p>
              <router-link class='navigation-balance' to='/account'>{`${FormatCurrency(this.$store.getters.BALANCE)}`}</router-link>
            </div>
            
            {loader}
            <LiveList></LiveList>
            <GameFooter></GameFooter>
        </DefaultLayout>
    );
  }
}
